// extracted by mini-css-extract-plugin
export default {"input":"J8-z","button":"K8-z","selected":"L8-z","unavailable":"M8-z","oos":"N8-z","image":"O8-z","paperCutDisabledOverlay":"P8-z"};